_ = require 'underscore'

class ClientConfig
  constructor: (config = {}) -> @config = _.clone(config)
  get: (name) -> @config[name] || null

module.exports = new ClientConfig(window.init_config)



// WEBPACK FOOTER //
// ./app/scripts/debug/client-config.coffee